module.exports = __webpack_public_path__ + "static/media/photo-2.6f03fa87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/cambridge-student-accommodation/photo-2.jpg
// module id = 154
// module chunks = 0